module.exports = __webpack_public_path__ + "img/5.412f06f9.jpg";